import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Info';

const styles = (theme:Theme):any => ({
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  itemicon: {
    minWidth: 24,
    marginRight: 8,
  }
});

class DynamicMenuChild extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  
  componentDidMount() {
    // So we only run this logic once.
    if (!this.props.openImmediately) {
      return;
    }

    // Center the selected item in the list container.
    const activeElement = document.querySelector(`.${this.props.classes.active}`);
    if (activeElement && activeElement.scrollIntoView) {
      activeElement.scrollIntoView({});
    }
  }

  render() {
    const {
      children,
      classes,
      index,
      action,
      onClick,
      openImmediately,
      title,
      ...other
    } = this.props;

    return (
      <ListItem button onClick={onClick(null,action,index)} {...other} className={classes.nested}> 
        <ListItemIcon className={classes.itemicon}>
          <MenuIcon />
        </ListItemIcon>
        <ListItemText primary={title} />
      </ListItem>
    );
    
  }
}

DynamicMenuChild.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  openImmediately: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

DynamicMenuChild.defaultProps = {
  openImmediately: false,
};

export default withStyles(styles)(DynamicMenuChild);
